<template>
  <div>
    <div class="header-unisinos" style="position: fixed;">
      <v-container class="py-1 my-0">
        <img src="//www.unisinos.br/images/logos/unisinos-logo-branco.svg" alt="Unisinos" style="height: 24px; padding: 0px 0px 0px" />
      </v-container>
    </div>
    <v-app-bar app color="white" flat height="124px">
      <v-container style="margin-top: 32px">
        <v-row align="center" justify="center">
          <v-col md="4" cols="12" :class="route === '/' ? 'text-center' : ''">
            <img src="@/assets/horizontal.png" style="max-width:100%;max-height:38px;" class="fakeLink" @click="goTo('/')" />
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    route() {
      return this.$route.path
    },
  },
  methods: {
    goTo(rota) {
      this.$router.push(rota)
    },
  },
}
</script>

<style></style>
